<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :class="[`${prefix}-icon`, `${prefix}-icon-psm-mail-full`]" width="1em" height="1em" v-bind="$attrs"><defs><path id="svg_d96febfd98__a" d="M0 0L109 0 109 82 0 82z"/></defs><g transform="translate(10 24)" fill="none" fill-rule="evenodd"><mask id="svg_d96febfd98__b" :fill="useCurrentColor ? 'currentColor' : '#fff'"><use xlink:href="#svg_d96febfd98__a"/></mask><path d="M10.8532755,0 L98.1000914,0 C104.053532,0 108.927516,4.20250513 109,9.37866134 L54.5053223,35.8748436 L0,9.40448657 C0.0519048102,4.2127151 4.87915354,0 10.8532755,0 Z M0.0519048102,20.52555 L0,71.6476876 C0,77.3415493 4.90490319,82 10.9000101,82 L98.1000914,82 C104.095097,82 109,77.3415493 109,71.6476876 L109,20.5001251 L55.8030441,48.0571436 C54.9876722,48.4825592 54.0123278,48.4825592 53.1973618,48.0571436 L0.0467346045,20.52555 L0.0519048102,20.52555 Z" :fill="useCurrentColor ? 'currentColor' : '#1BA8AF'" fill-rule="nonzero" mask="url(#svg_d96febfd98__b)"/></g></svg>
</template>
<script>

export default {
  name: 'IconPsmMailFull',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
